const ar: Record<string, string> = {
  // Navigation
  'nav.features': 'الميزات',
  'nav.try': 'جرّب',
  'nav.download': 'تحميل',

  // Hero
  'hero.title1': 'اكتشف ما',
  'hero.title2': 'تخبرك به',
  'hero.title3': 'أحلامك.',
  'hero.subtitle': 'افتح أسرار اللاوعي في ثوانٍ. استيقظ مع مرشدك الشخصي للأحلام الذي يجمع بين المصادر الإسلامية والذكاء الاصطناعي الحديث.',

  // Features
  'features.badge': 'الميزات',
  'features.title1': 'لماذا',
  'features.title2': 'حكمة الرؤيا؟',
  'features.subtitle': 'المزج المثالي بين الحكمة القديمة والتكنولوجيا الحديثة.',
  'features.dreamJournal.title': 'لا تفقد أي تفصيل',
  'features.dreamJournal.desc': 'سجّل أحلامك لحظة استيقاظك واحفظ رحلتك الداخلية بأمان.',
  'features.aiInterpretation.title': 'معانٍ عميقة وشخصية',
  'features.aiInterpretation.desc': 'إرشاد ذكي يركّز على سياق حلمك، وليس على الكلمات فقط.',
  'features.nightMode.title': 'استعد لنوم هادئ',
  'features.nightMode.desc': 'ادخل إلى الليل بمحتوى مهدّئ يساعد عقلك على الاسترخاء قبل النوم.',
  'features.unlock': 'افتح أحلامك',

  // Dream Input
  'dreamInput.badge': 'جرب الآن',
  'dreamInput.title1': 'اكتشف',
  'dreamInput.title2': 'حلمك',
  'dreamInput.placeholder': 'ماذا رأيت الليلة الماضية؟ شاركنا كل التفاصيل ولنفسّر معاً...',
  'dreamInput.interpret': 'فسّر',
  'dreamInput.interpreting': 'جارٍ التفسير...',
  'dreamInput.aiTitle': 'تفسير الذكاء الاصطناعي',
  'dreamInput.notDreamTitle': 'معلومات',
  'dreamInput.notDreamWarning': 'مرحباً! أنا ذكاء اصطناعي أفسر الأحلام وفقاً للمصادر الإسلامية. 🌙 يرجى وصف حلم رأيته، وسأفسره لك بأفضل طريقة.',
  'dreamInput.sources': '📚 المصادر:',
  'dreamInput.seeMore': '🔓 انقر لرؤية التفسير الكامل',
  'dreamInput.unlockFull': 'سجّل الدخول للتطبيق لفتح التفسير الكامل والمزيد.',
  'dreamInput.error': 'حدث خطأ أثناء الحصول على التفسير. يرجى المحاولة مرة أخرى.',
  'dreamInput.authRequired': 'تحتاج إلى تسجيل الدخول للحصول على تفسير الأحلام.',
  'dreamInput.newDream': '✨ اكتب حلماً جديداً',

  // Ticker
  'ticker.lucidDreaming': 'الحلم الواعي',
  'ticker.psychology': 'علم النفس',
  'ticker.astrology': 'علم الفلك',
  'ticker.symbolAnalysis': 'تحليل الرموز',
  'ticker.dreamJournal': 'مذكرة الأحلام',
  'ticker.aiInsights': 'رؤى الذكاء الاصطناعي',
  'ticker.sleepPatterns': 'أنماط النوم',
  'ticker.subconscious': 'اللاوعي',
  'ticker.review1': 'كنت أحلم باستمرار بأنني أسقط من جرف. بعد التفسير واجهت مصدر التوتر في حياتي. لا يصدق.',
  'ticker.review2': 'كانت أمي تظهر في أحلامي وكان ذلك يقلقني دائماً. تعلم المعنى هنا منحني سلاماً حقيقياً.',
  'ticker.review3': 'رأيت نفس الكابوس لأشهر. حتى التفسير الأول أراني ما كان مخفياً.',
  'ticker.review4': 'أكتب حلمي فور استيقاظي. بعد بضعة أسابيع أصبحت أعرف نفسي أفضل بكثير.',
  'ticker.review5': 'استناده إلى المصادر الإسلامية مهم بالنسبة لي. تقليدي وحديث في آنٍ واحد.',

  // Footer
  'footer.title': 'هل أنت مستعد لأحلام أعمق؟',
  'footer.subtitle': 'حمّل حكمة الرؤيا وابدأ رحلتك إلى اللاوعي الليلة.',
  'footer.scanToDownload': 'امسح للتحميل',
  'footer.startJourney': 'ابدأ تفسير الأحلام الآن',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الاستخدام',
  'footer.deleteAccount': 'حذف الحساب',
  'footer.contact': 'اتصل بنا',
  'footer.rights': '© 2026 حكمة الرؤيا. جميع الحقوق محفوظة.',

  // Contact Dialog
  'contact.title': 'اتصل بنا',
  'contact.company': 'التطبيق',
  'contact.email': 'البريد الإلكتروني',
  'contact.description': 'لا تتردد في التواصل معنا لأسئلتكم واقتراحاتكم وملاحظاتكم. سنعود إليك في أقرب وقت ممكن.',

  // Privacy Policy Dialog
  'privacy.title': 'سياسة الخصوصية',
  'privacy.lastUpdated': 'آخر تحديث: 30.04.2026',
  'privacy.intro': 'تلتزم حكمة الرؤيا ("التطبيق"، "نحن") بحماية خصوصية مستخدمينا وتخزين البيانات الشخصية بأمان.',
  'privacy.acceptance': 'بتنزيل التطبيق أو استخدامه، فإنك تقبل شروط هذه السياسة.',
  'privacy.section1.title': '1. البيانات المجمعة',
  'privacy.section1a.title': 'أ. المعلومات التي تقدمها:',
  'privacy.section1a.item1.label': 'معلومات الحساب:',
  'privacy.section1a.item1.text': 'عنوان البريد الإلكتروني والاسم (اختياري) أو بيانات تسجيل الدخول عبر وسائل التواصل الاجتماعي.',
  'privacy.section1a.item2.label': 'محتوى الأحلام واليوميات:',
  'privacy.section1a.item2.text': 'روايات الأحلام المدخلة كنص أو صوت من خلال ميزات "إضافة حلم" أو "مذكرة أحلامي".',
  'privacy.section1a.item3.label': 'بيانات التخصيص:',
  'privacy.section1a.item3.text': 'الحالة الاجتماعية والعمر والجنس أو معلومات التوظيف المشاركة طوعياً لتفسيرات أكثر دقة.',
  'privacy.section1a.item4.label': 'طلبات الاتصال:',
  'privacy.section1a.item4.text': 'الملاحظات وتقارير الأخطاء المشاركة مع الدعم.',
  'privacy.section1b.title': 'ب. البيانات التقنية المجمعة تلقائياً:',
  'privacy.section1b.item1.label': 'معلومات الجهاز:',
  'privacy.section1b.item1.text': 'طراز الجهاز، إصدار نظام التشغيل، دقة الشاشة، اللغة المفضلة.',
  'privacy.section1b.item2.label': 'بيانات الاستخدام:',
  'privacy.section1b.item2.text': 'مدة الجلسات داخل التطبيق، النقرات على الأزرار، تكرار استخدام الميزات.',
  'privacy.section1b.item3.label': 'معلومات الموقع:',
  'privacy.section1b.item3.text': 'بيانات موقع تقريبية على مستوى المدينة/المنطقة مطلوبة فقط لميزة "أوقات الصلاة".',
  'privacy.section2.title': '2. أغراض معالجة البيانات',
  'privacy.section2.item1': 'إنشاء وتقديم تفسيرات الأحلام المدعومة بالذكاء الاصطناعي.',
  'privacy.section2.item2': 'تخزين أحلامك السابقة بترتيب زمني في "مذكرة أحلامي".',
  'privacy.section2.item3': 'حساب أوقات الصلاة بناءً على موقعك.',
  'privacy.section2.item4': 'ضمان أمان التطبيق وإصلاح المشكلات التقنية.',
  'privacy.section2.item5': 'الوفاء بالتزاماتنا القانونية.',
  'privacy.section3.title': '3. مشاركة البيانات والأطراف الثالثة',
  'privacy.section3.item1': 'تتم معالجة نصوص الأحلام بشكل مجهول الهوية للتفسير.',
  'privacy.section3.item2': 'يستخدم لقاعدة بيانات المستخدمين والمصادقة والتخزين السحابي الآمن لسجلات الأحلام.',
  'privacy.section3.item3': 'يستخدم للمشتريات داخل التطبيق وتسجيل الدخول الآمن.',
  'privacy.section3.item4.label': 'السلطات القانونية:',
  'privacy.section3.item4.text': 'قد يتم مشاركتها مع السلطات الرسمية في حالة أمر المحكمة أو الالتزام القانوني.',
  'privacy.section4.title': '4. أمان البيانات والتخزين',
  'privacy.section4.item1.label': 'الأمان:',
  'privacy.section4.item1.text': 'بياناتك محمية بأساليب TLS/SSL والتشفير.',
  'privacy.section4.item2.label': 'فترة التخزين:',
  'privacy.section4.item2.text': 'يتم تخزين سجلات الأحلام طالما لم تحذف حسابك.',
  'privacy.section4.item3.label': 'حذف الحساب:',
  'privacy.section4.item3.text': 'يتم حذف جميع بياناتك نهائياً خلال 72 ساعة عند حذف حسابك.',
  'privacy.section5.title': '5. حقوق المستخدم',
  'privacy.section5.item1': 'معرفة ما إذا كانت بياناتك قيد المعالجة.',
  'privacy.section5.item2': 'طلب حذف أو إتلاف بياناتك.',
  'privacy.section5.item3': 'طلب تصحيح بياناتك.',
  'privacy.section5.item4': 'الاعتراض على نتيجة ضدك.',
  'privacy.section5.contact': 'اتصل: info@ruyahikmeti.com (رد خلال 30 يوماً)',
  'privacy.section6.title': '6. خصوصية الأطفال',
  'privacy.section6.text': 'هذا التطبيق غير مخصص للاستخدام من قبل الأطفال دون سن 13 عاماً.',
  'privacy.section7.title': '7. اتصل بنا',
  'privacy.section7.company': 'التطبيق:',
  'privacy.section7.emailLabel': 'البريد الإلكتروني:',

  // Terms of Service Dialog
  'terms.title': 'شروط الاستخدام',
  'terms.lastUpdated': 'آخر تحديث: 30.04.2026',
  'terms.intro': 'تنظم شروط الاستخدام هذه استخدامك لتطبيق حكمة الرؤيا ("التطبيق"). بتنزيل التطبيق أو إنشاء حساب أو استخدامه، فإنك تقبل هذه الشروط.',
  'terms.section1.title': '1. وصف الخدمة',
  'terms.section1.text': 'حكمة الرؤيا هو تطبيق جوال يمكن للمستخدمين من خلاله تسجيل أحلامهم والحصول على تفسيرات مدعومة بالذكاء الاصطناعي تستند إلى المصادر الإسلامية. التفسيرات لأغراض إعلامية فقط ولا تحل محل النصيحة الدينية أو الطبية أو النفسية.',
  'terms.section2.title': '2. حساب المستخدم',
  'terms.section2.item1': 'يجب أن يكون عمرك 13 عاماً على الأقل لإنشاء حساب.',
  'terms.section2.item2': 'أنت مسؤول عن سرية بيانات حسابك وعن جميع الأنشطة التي تتم من خلاله.',
  'terms.section2.item3': 'توافق على عدم تقديم معلومات كاذبة أو مضللة.',
  'terms.section3.title': '3. الاستخدام المقبول',
  'terms.section3.intro': 'توافق على عدم استخدام التطبيق لـ:',
  'terms.section3.item1': 'إرسال محتوى غير قانوني أو ضار أو مهدد أو مسيء أو غير لائق.',
  'terms.section3.item2': 'انتهاك حقوق الملكية الفكرية للآخرين.',
  'terms.section3.item3': 'تعريض أمان التطبيق للخطر أو محاولة الهندسة العكسية.',
  'terms.section3.item4': 'الوصول إلى النظام باستخدام أدوات آلية (بوتات، سكرابرز).',
  'terms.section4.title': '4. الملكية الفكرية',
  'terms.section4.text': 'جميع النصوص والرسومات والشعارات والأيقونات والصور وكود البرنامج والبيانات في التطبيق مملوكة لحكمة الرؤيا ومحمية بقوانين حقوق النشر والعلامات التجارية والملكية الفكرية. لا يجوز نسخها أو توزيعها أو تعديلها دون إذن خطي.',
  'terms.section5.title': '5. محتوى المستخدم',
  'terms.section5.text': 'نصوص الأحلام التي تدخلها في التطبيق ملك لك. ومع ذلك، فإنك تمنحنا الإذن بمعالجة هذا المحتوى لتقديم تفسير الذكاء الاصطناعي والحفاظ على الخدمة. تتم معالجة محتواك وفقاً لسياسة الخصوصية الخاصة بنا.',
  'terms.section6.title': '6. الاشتراك والمدفوعات',
  'terms.section6.text': 'تتطلب بعض الميزات اشتراكاً مدفوعاً. تتم إدارة الاشتراكات من خلال حساب Apple App Store أو Google Play. سيتجدد اشتراكك تلقائياً ما لم يتم إلغاؤه قبل 24 ساعة على الأقل من نهاية الفترة الحالية. تخضع طلبات الاسترداد لسياسات المنصة المعنية.',
  'terms.section7.title': '7. إخلاء المسؤولية',
  'terms.section7.text': 'يتم تقديم تفسيرات حكمة الرؤيا فقط لأغراض إعلامية وإرشاد روحي. لا تحل محل النصيحة الطبية أو النفسية أو الدينية المهنية. يتم تقديم التطبيق "كما هو" دون أي ضمان صريح أو ضمني للتشغيل المستمر أو الخالي من الأخطاء.',
  'terms.section8.title': '8. حدود المسؤولية',
  'terms.section8.text': 'إلى أقصى حد يسمح به القانون المعمول به، لن تكون حكمة الرؤيا مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية تنشأ عن استخدامك للتطبيق.',
  'terms.section9.title': '9. الإنهاء',
  'terms.section9.text': 'نحتفظ بالحق في تعليق حسابك أو إنهائه دون إشعار مسبق إذا انتهكت هذه الشروط. يمكنك حذف حسابك في أي وقت من داخل التطبيق أو بإرسال طلب إلى info@ruyahikmeti.com.',
  'terms.section10.title': '10. التغييرات',
  'terms.section10.text': 'قد نقوم بتحديث هذه الشروط من وقت لآخر. سيتم إخطار التغييرات الجوهرية داخل التطبيق أو عبر البريد الإلكتروني. استمرارك في استخدام التطبيق بعد التحديث يعني قبولك للشروط الجديدة.',
  'terms.section11.title': '11. القانون المعمول به',
  'terms.section11.text': 'تخضع هذه الشروط لقوانين جمهورية تركيا. تختص محاكم وإدارات تنفيذ إسطنبول بحل أي نزاعات.',
  'terms.section12.title': '12. اتصل بنا',
  'terms.section12.text': 'للأسئلة: info@ruyahikmeti.com',

  // Delete Account Dialog
  'delete.title': 'حذف الحساب',
  'delete.intro': 'يمكنك حذف حسابك وجميع البيانات المرتبطة به (سجلات الأحلام، معلومات الملف الشخصي، الإعدادات) بشكل دائم. هذا الإجراء لا يمكن التراجع عنه.',
  'delete.method1.title': 'الطريقة 1: من داخل التطبيق (موصى بها)',
  'delete.method1.step1': 'افتح التطبيق وسجل الدخول.',
  'delete.method1.step2': 'انتقل إلى الملف الشخصي > الإعدادات > الحساب.',
  'delete.method1.step3': 'انقر على "حذف الحساب".',
  'delete.method1.step4': 'بعد التأكيد، سيتم حذف حسابك وجميع البيانات نهائياً خلال 72 ساعة.',
  'delete.method2.title': 'الطريقة 2: طلب بالبريد الإلكتروني',
  'delete.method2.text': 'إذا لم تتمكن من الوصول إلى التطبيق، أرسل بريداً إلكترونياً من العنوان المرتبط بحسابك يحتوي على ما يلي:',
  'delete.method2.item1': 'الموضوع: "طلب حذف الحساب"',
  'delete.method2.item2': 'البريد الإلكتروني المرتبط بحسابك',
  'delete.method2.item3': 'ملاحظة تحقق قصيرة',
  'delete.method2.email': 'إرسال إلى: info@ruyahikmeti.com',
  'delete.method2.timeline': 'سيتم حذف حسابك خلال 72 ساعة من استلام الطلب، وسيتم إرسال بريد تأكيد.',
  'delete.deletedData.title': 'البيانات التي سيتم حذفها',
  'delete.deletedData.item1': 'معلومات الحساب (البريد الإلكتروني، الاسم)',
  'delete.deletedData.item2': 'جميع سجلات الأحلام وإدخالات اليوميات',
  'delete.deletedData.item3': 'سجل التفسيرات والمفضلة',
  'delete.deletedData.item4': 'الإعدادات والتفضيلات',
  'delete.retainedData.title': 'البيانات التي قد يتم الاحتفاظ بها',
  'delete.retainedData.text': 'قد يتم الاحتفاظ ببعض سجلات المعاملات في شكل مجهول الهوية بسبب الالتزامات القانونية (الضرائب، الفواتير، المراسلات القانونية) بموجب قانون حماية البيانات المعمول به.',
  'delete.contactButton': 'إرسال طلب الحذف',

  // Phone Mockup
  'phone.dream': 'رأيت في حلمي قمراً مضيئاً في السماء والنجوم ترقص...',
  'phone.aiLabel': 'تفسير الذكاء الاصطناعي',
  'phone.aiResponse': 'رؤية القمر ترمز إلى العلم والحكمة. بشير بمرشد سيدخل حياتك...',

  // Sample Interpretations
  'dreamInterpretation1': 'الماء الذي رأيته في حلمك يرمز إلى التطهير الروحي والتجديد. وفقاً لابن سيرين، رؤية الماء الصافي بشير بالأخبار السارة. عقلك الباطن يذكرك ببحثك عن السلام الداخلي.',
  'dreamInterpretation2': 'الطيران في الحلم رمز للصعود الروحي والبحث عن الحرية. يظهر أن لديك القوة للتغلب على العقبات التي تواجهها. عالمك الداخلي يهمس أنك تستطيع تجاوز حدودك.',
  'dreamInterpretation3': 'القمر الذي رأيته، وفقاً للمصادر الإسلامية، يمثل العلم والحكمة. قد يكون نذيراً بدخول مرشد أو شخص حكيم إلى حياتك. فترة ستملأ قلبك بالنور في انتظارك.',

  // Legal pages
  'legal.openAsPage': 'فتح كصفحة كاملة',
  'legal.backHome': 'العودة إلى الرئيسية',
};

export default ar;
